/* eslint-disable max-lines */
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import LoadingSection from "../../../components/auth/LoadingSection";
import Button from "../../../components/ui/Button";
import Table, { Row } from "../../../components/ui/table";
import withProtected from "../../../hoc/withProtected";
import useFetch from "../../../hooks/useFetch";
import { getOperatorSalesPerDate } from "../../../services/Analytics.service";
import _404 from "../../404";

const columns = [
  "Lloji",
  "Emri",
  "Mbiemri",
  "Booking ID",
  "Passport ID",
  "Ulëse Shkuese"
];

const LineSales = () => {
  const [showButton, setShowButton] = useState(true);
  const [searchParams] = useSearchParams();
  const { response, loading, error } = useFetch(getOperatorSalesPerDate, {
    initRequest: true,
    params: {
      lineId: searchParams.get("lineId") || "",
      dateFrom: searchParams.get("df") || "",
      dateTo: searchParams.get("dt") || ""
    }
  });

  useEffect(() => {
    window.onbeforeprint = () => setShowButton(false);
    window.onafterprint = () => setShowButton(true);
  }, []);
  const onPrint = () => {
    setShowButton(false);
    setTimeout(() => {
      print();
    }, 0);
  };

  if (loading) return <LoadingSection />;
  if (error) return <_404 title="Kjo linje nuk u gjete!" />;
  return (
    <div className="container my-8 px-4 md:mx-auto">
      <style>{" @page { margin: 0cm !important; }"}</style>
      <div className="border-b-2 border-gray-200 pb-3 flex justify-between">
        {response?.data[0].operator.pictureUrl ? (
          <img
            src={response?.data[0].operator.pictureUrl}
            alt=""
            className="w-24 h-10 object-contain object-left"
          />
        ) : (
          <div className="font-medium text-neutral text-2xl">
            {response?.data[0].operator.name}
          </div>
        )}
        {showButton ? (
          <Button
            btnType="custom"
            className=" bg-gradient-to-bl from-primary to-pink text-white text-sm
            rounded-lg shadow-bottom"
            rounded={false}
            padding="px-8 py-2.5"
            onClick={onPrint}
          >
            Printo
          </Button>
        ) : null}
      </div>

      <div className="flex gap-10 items-center mt-5">
        <h1 className="text-base font-bold mb-5 ">Detajet e Pasagjerëve</h1>
        <div className="flex gap-1 flex-col mb-3 border-l-2 pl-10 border-gray-200 ">
          <p className="text-xs text-neutral">Data</p>
          <div className="flex gap-5 items-center">
            <p className="font-bold text-base">
              {dayjs(response?.data[0].journeyDate).format("DD MMMM YYYY")}
            </p>
            {response?.data[0].journeyDate !==
              response?.data[response.data.length - 1].journeyDate && (
              <>
                <ArrowRightIcon className="h-4 w-4" />
                <p className="font-bold text-base">
                  {dayjs(
                    response?.data[response.data.length - 1].journeyDate
                  ).format("DD MMMM YYYY")}
                </p>
              </>
            )}
          </div>
        </div>
      </div>

      {response?.data.map((item) => (
        <div className="mt-6">
          {item.journeysByLine.map((journey, index) => {
            return (
              <>
                <div key={index} className="">
                  <div className="flex flex-col md:flex-row gap-8 mb-6">
                    <div className="flex flex-col gap-1">
                      <p className="text-xs text-neutral">Linja</p>
                      <div className="flex gap-2 items-center text-sm font-bold">
                        <p className="font-bold ">
                          {journey.line.departureCity}
                          <span className="text-xs text-neutral font-normal ml-0.5">
                            ({journey.line.departureStation})
                          </span>
                        </p>
                        <ArrowRightIcon className="h-4 w-4" />
                        <p className="font-bold ">
                          {journey.line.arrivalCity}
                          <span className="text-xs text-neutral font-normal ml-0.5">
                            ({journey.line.arrivalStation})
                          </span>
                        </p>
                      </div>
                       {response?.data[0].journeyDate !==
                          response?.data[response.data.length - 1]
                            .journeyDate && (
                          <p className="font-semibold text-base">
                            {dayjs(item.journeyDate).format("DD MMMM YYYY")}
                          </p>
                        )}
                    </div>
                  </div>
                  {journey.journeys.map((j, i) => (
                    <div className="mb-8" key={i}>
                      <div className="flex gap-1 flex-col mb-3">
                        <p className="flex gap-2 items-center  text-base font-semibold">
                          <span>{j.trip.departureTime} </span>
                          <ArrowRightIcon className="h-4 w-4" />
                          <span>{j.trip.arrivalTime} </span>
                        </p>
                      </div>
                      <Table
                        titles={columns}
                        className="bg-gray-50"
                        thClassName="bg-gray-50"
                        style="border"
                      >
                        {j.clients.map((c) => (
                          <Row
                            key={c.bookingId}
                            passengersType={c.passengerType || "--"}
                            name={c.name}
                            lastName={c.lastName}
                            bookingId={
                              <a
                                className="underline text-blue"
                                href={c.pdfUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {c.bookingId}
                              </a>
                            }
                            passportId={c.passportId || "--"}
                            seat={c.seatNumber || "--"}
                          />
                        ))}
                      </Table>
                    </div>
                  ))}
                </div>
              </>
            );
          })}
        </div>
      ))}
    </div>
  );
};
export default withProtected(LineSales, true);
